module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);
var PropTypes = __webpack_require__(1);

var IdentificationCard = function IdentificationCard(props) {
  var placeHolder = props.placeHolder;

  var liStyleName = {};
  var liStyleNumber = {};
  var name = props.name.substr(0, props.maxLength.name);
  var number = props.number.substr(0, props.maxLength.number);

  if (name.length < 16) {
    liStyleName.fontSize = 'inherit';
  } else {
    liStyleName.fontSize = 150 - name.length * 2.8 + '%';
  }

  if (number.length < 14) {
    liStyleNumber.fontSize = 'inherit';
  } else {
    liStyleNumber.fontSize = 130 - number.length * 2.8 + '%';
  }

  return React.createElement(
    'div',
    { className: 'identification-card', 'data-hj-suppress': true },
    React.createElement('div', { className: 'identification-card-avatar' }),
    React.createElement(
      'ul',
      { className: 'identification-card__list' },
      React.createElement(
        'li',
        null,
        React.createElement(
          'span',
          { style: liStyleName, className: !name ? 'show-placeholder' : '' },
          name || placeHolder.name
        )
      ),
      React.createElement(
        'li',
        null,
        React.createElement(
          'span',
          { style: liStyleNumber, className: !number ? 'show-placeholder' : '' },
          number || placeHolder.number
        )
      )
    )
  );
};

IdentificationCard.propTypes = {
  name: PropTypes.string,
  number: PropTypes.string,
  placeHolder: PropTypes.shape({
    name: PropTypes.string,
    number: PropTypes.string
  }),
  maxLength: PropTypes.shape({
    name: PropTypes.number,
    number: PropTypes.number
  })
};

IdentificationCard.defaultProps = {
  name: '',
  number: '',
  placeHolder: {},
  maxLength: {
    name: 24,
    number: 24
  }
};

module.exports = IdentificationCard;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ })
/******/ ]);